import {isNil} from 'ramda';

import type {Nullish} from 'shared/web';

import type {GridDataChange} from '../types/GridDataChange';

/**
 * True while a host cannot trust `GridDataChange.rows`: no notification has arrived yet
 * (grid not mounted, or the legacy engine which never reports), or a fetch is in flight
 * (rows still hold the OUTGOING page). The single host-facing loading policy for
 * `onGridDataChange` payloads — derive from this instead of re-implementing the check.
 */
export const isGridDataLoading = (gridData: GridDataChange | Nullish): boolean =>
  isNil(gridData) || gridData.fetchState === 'loading';
